import { Link } from '../lib/routing';
import { CHAT_MODE_ICON, type ChatThread } from '../lib/chat-api';
import { threadRoute } from '../lib/thread-route';
import { relativeFr } from '../lib/humanize';

/* `to` explicite pour les listes qui connaissent une cible que le mode seul ne
   donne pas — la page des conversations d'un élève, dont la route porte
   l'identifiant de l'enfant. Sinon la destination vient du mode du fil. */
export default function ThreadRow({ thread, to }: { thread: ChatThread; to?: string }) {
  return (
    <Link to={to ?? threadRoute(thread) ?? `/c/${thread.id}`} className="flex items-center gap-3 px-[14px] py-3 border-b border-border text-foreground no-underline">
      <div className="text-[22px]">{CHAT_MODE_ICON[thread.mode]}</div>
      <div className="flex-1 min-w-0">
        <div className="font-bold text-[15px] line-clamp-2 break-words" title={thread.title}>
          {thread.title}
        </div>
        <div className="text-xs text-muted-foreground">
          {relativeFr(thread.last_message_at)}
        </div>
      </div>
      <div className="text-muted-foreground text-[18px]">›</div>
    </Link>
  );
}
